module.exports = __webpack_public_path__ + "img/chanpin.60ec6b3b.png";